import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpComponent } from './help.component';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';

const routes: Routes = [
  { path: 'help', component: HelpComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HelpRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/help/help-routing.module.ts